<template>
  <span class="svg-icon-arrow-chevron-left">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2799 4.19606C15.5728 4.48895 15.5728 4.96382 15.2799 5.25672L9.41054 11.1269C8.93344 11.604 8.93344 12.3891 9.41054 12.8662L15.2803 18.736C15.5732 19.0289 15.5732 19.5037 15.2803 19.7966C14.9874 20.0895 14.5126 20.0895 14.2197 19.7966L8.34988 13.9269C7.28699 12.864 7.28699 11.1291 8.34988 10.0662L14.2193 4.19606C14.5122 3.90316 14.987 3.90316 15.2799 4.19606Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    isSolid: { type: Boolean },
  }
}
</script>